import React from 'react'
import { MenuSelectStyle } from './style'

type MenuSelectProps = React.FC<{
  setChangeArea: React.Dispatch<React.SetStateAction<string>>
}>

export const MenuSelect: MenuSelectProps = ({ setChangeArea }) => {
  return (
    <MenuSelectStyle>
      <p>Escolha uma das opções abaixo.</p>
      <div>
        <button className="first" onClick={() => setChangeArea('Validar Código')}>
          Validar Código
        </button>
        <button className="second" onClick={() => setChangeArea('Re-enviar Código')}>
          Re-enviar Código
        </button>
        <button className="third" onClick={() => setChangeArea('Alterar Celular')}>
          Alterar Celular
        </button>
      </div>
    </MenuSelectStyle>
  )
}
